<template>
  <div
    class="absolute bottom-full mb-1 left-0 right-0 z-50 max-h-[18rem] overflow-y-auto overscroll-contain bg-white dark:bg-neutral-900 border border-gray-200 dark:border-neutral-700 rounded-xl shadow-lg"
  >
    <div
      v-for="(shortcut, index) in shortcuts"
      :key="shortcut.id"
      :ref="(element) => setItemRef(element, index)"
      class="flex items-center gap-3 px-3 py-2.5 cursor-pointer hover:bg-gray-50 dark:hover:bg-neutral-800 transition-colors"
      :class="{ 'bg-gray-50 dark:bg-neutral-800': index === activeIndex }"
      @click="$emit('select', shortcut)"
    >
      <span
        class="text-xs font-mono bg-gray-100 dark:bg-neutral-700 text-[var(--p-primary-color)] rounded px-1.5 py-0.5 flex-shrink-0 whitespace-nowrap"
      >
        /{{ shortcut.name }}
      </span>
      <div class="min-w-0 flex-1">
        <div
          class="text-sm font-medium text-[var(--p-surface-900)] dark:text-[var(--p-surface-0)] truncate"
        >
          {{ shortcut.name }}
        </div>
        <div class="text-xs text-[var(--p-surface-500)] truncate">
          {{ shortcut.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { nextTick, ref, watch, type ComponentPublicInstance } from 'vue'
import type { MessageShortcutDto } from '@/services/shortcut/interfaces'

const props = defineProps<{
  shortcuts: MessageShortcutDto[]
  activeIndex: number
}>()

defineEmits<{
  select: [shortcut: MessageShortcutDto]
}>()

const itemRefs = ref<HTMLElement[]>([])

const setItemRef = (element: Element | ComponentPublicInstance | null, index: number) => {
  if (element instanceof HTMLElement) {
    itemRefs.value[index] = element
  }
}

watch(
  () => [props.activeIndex, props.shortcuts.length],
  () => {
    nextTick(() => {
      itemRefs.value[props.activeIndex]?.scrollIntoView({
        block: 'nearest',
      })
    })
  },
)
</script>
